import { TableColumn } from '@/classes'

const Columns = [new TableColumn('Message Template', 'message', true, 'asc', 'left'), new TableColumn('', 'action', false, 'desc', 'centered')]

export { Columns }
